import React, { useEffect, useRef, useState, useCallback } from 'react'
import { Grid, TextField, Box, Button } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Visibility as VisibilityIcon } from '@material-ui/icons'

import { LanguageCustomization } from '..'
import { SecondLevelBanner } from '../BannerPreview/components'

import { useFormContext } from 'react-hook-form'
import useCookieBanner from 'hooks/useCookieBanner'
import useStyles from './styles'

import constants from 'constants/index'

const {
  MENU_ITEMS_IDS,
  TEXT_FIELD_LVL_2_PLACEHOLDERS,
  ORDERED_TEXT_FIELDS_LEVEL_2,
  TEXT_FIELD_CONFIG_LEVEL_2,
} = constants.cookies.bannerTextOverride

const TextCustomizationLevel2 = () => {
  const classes = useStyles()
  const { setValue } = useFormContext()
  const {
    bannerTextsOverrides,
    updateBannerTextOverride,
    getBannerTextOverride,
    selectedLanguage,
  } = useCookieBanner()
  const debounceRef = useRef()
  const [openPreview, setOpenPreview] = useState(false)
  const handleOpenPreview = useCallback(() => setOpenPreview(true), [])
  const handleClosePreview = useCallback(() => setOpenPreview(false), [])

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      setValue('bannerTextsOverrides', bannerTextsOverrides, {
        shouldDirty: true,
      })
    }, 300)
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [bannerTextsOverrides, setValue])

  const handleChange = (fieldKey) => (e) => {
    updateBannerTextOverride(fieldKey, e.target.value)
  }

  const getPlaceholder = (fieldKey) => {
    return TEXT_FIELD_LVL_2_PLACEHOLDERS?.[selectedLanguage]?.[fieldKey] || ''
  }

  return (
    <Grid container spacing={2} className={classes.textCustomizationContainer}>
      <Grid item xs={12}>
        <LanguageCustomization />
        <Alert severity="info" className={classes.alert}>
          Ajuste os textos exibidos no segundo nível do banner. Deixe em branco
          para usar o padrão.
        </Alert>
      </Grid>
      {ORDERED_TEXT_FIELDS_LEVEL_2.map((fieldKey) => {
        const config = TEXT_FIELD_CONFIG_LEVEL_2[fieldKey]
        if (!config) return null
        const value = getBannerTextOverride(fieldKey)
        const placeholder = getPlaceholder(fieldKey)
        const isButtonField = fieldKey.startsWith('button.')
        return (
          <Grid item xs={isButtonField ? 4 : 12} key={fieldKey}>
            <TextField
              fullWidth
              label={config.label}
              value={value}
              onChange={handleChange(fieldKey)}
              multiline={config.multiline}
              minRows={config.multiline ? 4 : 1}
              InputLabelProps={{ shrink: true }}
              placeholder={placeholder}
            />
          </Grid>
        )
      })}
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            startIcon={<VisibilityIcon />}
            onClick={handleOpenPreview}
          >
            Visualizar
          </Button>
        </Box>
      </Grid>
      <SecondLevelBanner
        openSecondLevel={openPreview}
        handleCloseSecondLevel={handleClosePreview}
        menuItemId={MENU_ITEMS_IDS.SERVICE_CHANNEL_MENU_ITEM_ID}
      />
    </Grid>
  )
}

export default TextCustomizationLevel2
